'use client';

import { useEffect } from 'react';
import { reportFrontendError } from '@/lib/frontend-error-reporter';

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    reportFrontendError(error, { source: 'react-boundary', digest: error.digest });
  }, [error]);

  return (
    <html lang="ko">
      <body style={{ fontFamily: 'sans-serif', margin: 0 }}>
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', textAlign: 'center', padding: 24 }}>
          <div>
            <h1>페이지를 불러오지 못했습니다.</h1>
            <button type="button" onClick={reset}>
              다시 시도
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
